import React from 'react';
import { FiDownload } from 'react-icons/fi';
import './ActionButton.css';

const ExportButton = ({ onClick, title = 'Export', disabled = false, style = {}, className = '' }) => {
  return (
    <button
      className={`export-btn ${className}`}
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled && onClick) {
          onClick(e);
        }
      }}
      disabled={disabled}
      style={{ background: 'none', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', marginLeft: '8px', ...style }}
    >
      <FiDownload size={20} color={disabled ? '#ccc' : '#007bff'} />
    </button>
  );
};

export default ExportButton;
